export default class IEFlexBoxWorkAround {
    public preinitOnLoad(): void {
        if ((window.document as any).documentMode) { // Internet Explorer detection
            jq("body").css("width", "99%");
        }
    }

    public initOnReady(): void {
        if ((window.document as any).documentMode) { // Internet Explorer detection
            jq(".user-tabs").parent().css("width", "100vw");

            window.setTimeout(() => {
                jq("body").css("width", "100%");
            });
        }
    }
}
